<template>
  <div>
    <client-only>
      <AppInformation />
    </client-only>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center',
  middleware: [
    'naver-ads',
    'kakao-pixel'
  ]
})

const { ogUrl, ogTitle, keyword } = useSeo()

useSeoMeta({
  title: '버전정보',
  description: '유심사의 웹 정보를 확인할 수 있어요',
  ogType: 'website',
  ogUrl: () => ogUrl('settings/app-information'),
  ogTitle: () => ogTitle('버전정보'),
  ogDescription: '유심사의 웹 정보를 확인할 수 있어요',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('버전정보'),
  twitterDescription: '유심사의 웹 정보를 확인할 수 있어요',
  keywords: keyword('버전정보')
})

</script>
